'use memo';

import { Trans as TransBase } from 'react-i18next';

import { toI18nextT } from './i18next-helpers';
import type { LegacyStringTFunction } from './i18next-types';

type AppTransProps = Record<string, unknown> & {
  t?: LegacyStringTFunction;
};

export function Trans({ t, ...props }: AppTransProps) {
  return (
    <TransBase {...props} {...(t !== undefined ? { t: toI18nextT(t) } : {})} />
  );
}
